var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("SModalCentered", {
    attrs: {
      title: _vm.$t("stemdoerDetail.seniorityModal.title"),
      isOpen: _vm.isOpen,
      closeModal: _vm.onCancel,
      customProps: { bodyPaddingY: 0, fullWidthFooter: true },
      persistent: true,
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "d-flex flex-column" }, [
              _c("div", { staticClass: "mb-1 d-flex flex-column" }, [
                _c(
                  "span",
                  { staticClass: "text-body-1 text--text text--base mb-1" },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("stemdoerDetail.seniorityModal.current")
                        ) +
                        "\n          "
                    ),
                    _vm.currentSeniorityLabel
                      ? _c("span", [
                          _vm._v(
                            _vm._s(_vm.currentSeniorityLabel) +
                              " (" +
                              _vm._s(_vm.currentSeniority) +
                              ")"
                          ),
                        ])
                      : _c("span", [_vm._v(_vm._s(_vm.currentSeniority))]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mb-0" },
                [
                  _c(
                    "v-radio-group",
                    {
                      model: {
                        value: _vm.selectedSeniority,
                        callback: function ($$v) {
                          _vm.selectedSeniority = $$v
                        },
                        expression: "selectedSeniority",
                      },
                    },
                    _vm._l(_vm.seniorityOptions, function (option) {
                      return _c("v-radio", {
                        key: option.id,
                        attrs: {
                          label:
                            _vm.getSeniorityLabel(option.id) +
                            " (" +
                            _vm.$t("stemdoPlatformApp.seniority." + option.id) +
                            ")",
                          value: option.id,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "v-container",
              { staticClass: "pa-0" },
              [
                _c(
                  "v-row",
                  { attrs: { "no-gutters": "" } },
                  [
                    _c(
                      "v-col",
                      { staticClass: "mr-6" },
                      [
                        _c("SButton", {
                          attrs: {
                            action: _vm.onCancel,
                            btnStyle: "tertiary",
                            sText: "stemdoerDetail.seniorityModal.cancelButton",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-col",
                      [
                        _c("SButton", {
                          attrs: {
                            action: _vm.onSave,
                            btnStyle: "primary",
                            sText: "stemdoerDetail.seniorityModal.saveButton",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }